import ICLICommand from "flow/interfaces/ICLICommand";
import Writer from "flow/cli/Writer";
import sessionStorage from "flow/wrappers/sessionStorage";
import config from "flow/config";
import clearSelectedProductFromUserSettings from "flow/utils/clearSelectedProductFromUserSettings";
import workspace from "flow/viewModels/workspace";

export default {
    name: "forget-product",
    description: "Clears product selection from session storage and user settings.",
    options: [],
    arguments: [],
    callback(writer: Writer) {
        return new Promise(resolve => {
            sessionStorage.removeItem(config.storageKeys.selectedProduct);
            writer.output.writeLine("Product selection removed from session storage.");
            const myFlow = workspace.getMyFlow();
            clearSelectedProductFromUserSettings(myFlow)
                .then(() => {
                    writer.output.writeLine("Product selection removed from user settings.");
                    resolve({ input: "" });
                })
                .catch(() => {
                    writer.error.writeLine("Failed to clear product selection from user settings.");
                    resolve({
                        input: ""
                    });
                });
        });
    }
} as ICLICommand;
